import { render } from "./WpeTextarea.vue?vue&type=template&id=a31df028"
import script from "./WpeTextarea.vue?vue&type=script&lang=js"
export * from "./WpeTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a31df028"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a31df028', __exports__)) {
    api.reload('a31df028', __exports__)
  }
  
  module.hot.accept("./WpeTextarea.vue?vue&type=template&id=a31df028", () => {
    api.rerender('a31df028', render)
  })

}


export default __exports__